import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
`
export const Header = styled.div`
    display: flex;
    flex: 1;
    padding-top: 4px;
    padding-bottom: 28px;
    padding-left: 46px;
    padding-right: 46px;
    justify-content: flex-end;
`

export const AbsoluteContentContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  box-sizing: border-box;
  padding: 101px 46px 0px 46px;
`

export const ContentContainer = styled.div`
  flex: 1;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.05);
  background-color: ${C.WHITE};
  overflow-y: auto;
  transition: height 0.4s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
`

export const OrganizationContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: baseline;
  margin-top: -5px;
  height: min-content;
`

export const OrganizationTitle = styled.span`
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.WHITE};
`